import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'financingConfig';
const FIVE_MINUTES = 300000;
const keysFactory = {
    financingConfig: (merchantId, financingProgram) => [{ scope: SCOPE, merchantId, financingProgram }],
};
export async function getMerchantFinancingConfig(merchantId, financingProgramId) {
    const hasPrefix = merchantId.startsWith('alis*');
    const formattedMerchantId = hasPrefix ? merchantId : `alis*${merchantId}`;
    const response = await apiClient.get(`/Merchants/${encodeURIComponent(formattedMerchantId)}/FinancingConfigs/${financingProgramId}`);
    return response.data;
}
export function useMerchantFinancingConfig(merchantId, financingProgramId) {
    const { isFetching, data, error } = useQuery({
        queryKey: keysFactory.financingConfig(merchantId, financingProgramId),
        queryFn: () => getMerchantFinancingConfig(merchantId, financingProgramId),
        staleTime: FIVE_MINUTES,
        gcTime: FIVE_MINUTES,
        enabled: !!merchantId && merchantId.trim() !== '',
    });
    return [data ?? null, isFetching, error];
}
